import { format, isSameDay } from 'date-fns'

const formatMessageTime = (createdAt: number, now: number = Date.now()): string => (
  format(createdAt, isSameDay(createdAt, now) ? 'HH:mm' : 'dd/MM/yyyy HH:mm')
)

export { formatMessageTime }
